import React from 'react';
import { useSelector } from 'react-redux';
import UserForm from '../../../components/UserForm/UserForm';
import "./style.scss";

function AddUser() {
  const user = useSelector((state) => state.auth?.user?.data);

  if (user?.role_id !== 1) {
    return "Your are not authorized to view this page";
  }
    
  return (
    <div>
        <UserForm user={null} />
    </div>
  );
}

export default AddUser;
